import { render } from "./IconBaseLabel.vue?vue&type=template&id=6695c0e4"
import script from "./IconBaseLabel.vue?vue&type=script&lang=js"
export * from "./IconBaseLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__